import tinycolor from 'tinycolor2';

export function splitHex8(color) {
  const tc = tinycolor(color);
  if (!tc.isValid()) {
    return null;
  }

  const { r, g, b, a } = tc.toRgb(); // a is 0..1
  const baseHex = tinycolor({ r, g, b }).toHexString(); // "#rrggbb"
  const opacity = a; // 0..1
  const opacityPercent = Math.round(a * 100); // 0..100

  return { baseHex, opacity, opacityPercent };
}

export function changeColorOpacity(color, opacityPercent) {
  const tc = tinycolor(color);
  if (!tc.isValid()) {
    return null;
  }
  const { r, g, b } = tc.toRgb();
  const opacity = opacityPercent > 0 ? opacityPercent / 100 : 1;
  const hex = tinycolor({ r, g, b, a: opacity });
  return hex.toHex8String();
}
